// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const WORK_APR_PROCESSO = {
  OrdemDeCompra: 'WORK_APR_PROCESSO1',
  PurchaseOrder: 'WORK_APR_PROCESSO2',
  Comercial: 'WORK_APR_PROCESSO3',
  Credito: 'WORK_APR_PROCESSO4',
  ReanaliseComercialPorFinanciamentoDePv: 'WORK_APR_PROCESSO5',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    WORK_APR_PROCESSO1: 1,
    WORK_APR_PROCESSO2: 2,
    WORK_APR_PROCESSO3: 3,
    WORK_APR_PROCESSO4: 4,
    WORK_APR_PROCESSO5: 5
  }
}
